import { render, staticRenderFns } from "./SelectFormPermalink.vue?vue&type=template&id=2b71c87e&"
import script from "./SelectFormPermalink.vue?vue&type=script&lang=js&"
export * from "./SelectFormPermalink.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports